<template>
    <div v-if="id_pagamento_atendimento">
        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown"
            title="Integração Suporte POS" id="integracao-suportepos-status-button" aria-haspopup="true"
            aria-expanded="false">
            SuportPOS
        </button>

        <div class="dropdown-menu" aria-labelledby="integracao-suportepos-status-button">
            <a class="dropdown-item" href="#" @click="abrirModalRecepcao()"> Pagar </a>
            <!-- <a class="dropdown-item" href="#" @click="abrirModalCartao()"> Pagar com cartão </a> -->
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#" @click="abrirModalCancelamento()">
                Cancelar pagamento
            </a>

            <div v-for="item in itens_pagamento_atendimento" :key="item.id">
                <a class="dropdown-item" href="#" @click="logComunicacao(item.id_item_pagamento_atendimento)">
                    <i class="fa-solid fa-book fa-fw mr-2"></i>Log de Comunicação {{ item.forma_pagamento.search }}</a>
            </div>

        </div>

        <div class="modal fade" id="modalRecepcao" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <span>Escolha a recepção</span>
                        <button type="button" class="close" @click="fecharModalRecepcao()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group"
                            style="display: flex; justify-content: space-between; flex-direction: column;">
                            <table style=" border-collapse: separate; border-spacing: 15px">
                                <thead>
                                    <tr>
                                        <td>
                                            Recepção
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <select class="form form-control" v-model="maquininha">
                                                <option :value="null">
                                                    Selecione uma maquininha
                                                </option>

                                                <option v-for="recepcao in recepcoes_disponiveis"
                                                    :key="recepcao.id_configuracao_pagamento_ec" :value="recepcao">
                                                    {{ recepcao.st_nome_ec }} - {{ recepcao.st_id_logico }}
                                                </option>
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" style="float: right" @click="pagar()">
                            Enviar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalCancelamento" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <span>Cancelar Pagamento</span>
                        <button type="button" class="close" @click="fecharModalCancelamento()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group"
                            style="display: flex; justify-content: space-between; flex-direction: column;">
                            <table style=" border-collapse: separate; border-spacing: 15px">
                                <thead>
                                    <tr>
                                        <td>Selecionar</td>
                                        <td>Forma</td>
                                        <td>Valor</td>
                                        <td>NSU</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="pagamento in pagamentos" :key="pagamento.id_item">
                                        <td>
                                            <Checkbox :id="pagamento.id_item" :name="pagamento.id_item"
                                                :value="pagamento.id_item" v-model="itens_cancelamento" />
                                        </td>
                                        <td>
                                            <div class="flex">{{ pagamento.forma_pagamento }}</div>
                                        </td>
                                        <td>
                                            <div class="flex">{{ moedaReal(pagamento.valor) }}</div>
                                        </td>
                                        <td>
                                            <div class="flex">{{ pagamento.nsu }}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- <div class="flex">
                            <div v-for="pagamento in pagamentos" :key="pagamento.id_pedido">
                                <Checkbox :id="pagamento.id_pedido" :name="pagamento.id_pedido"
                                    :value="pagamento.id_pedido" v-model="itens_cancelamento" />
                                <label :for="pagamento.id_pedido" class="p-checkbox-label">{{
                                    "Forma: " + pagamento.forma_pagamento + " | Valor: " + moedaReal(pagamento.valor)
                                    }}</label>
                            </div>
                        </div> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" style="float: right" @click="cancelarPagamento()">
                            Enviar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalErrosCancelamentos" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <span>Erros no Cancelamento</span>
                        <button type="button" class="close" @click="fecharModalErrosCancelamentos()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="flex">
                            <div v-for="erro_cancelamento in erros_cancelamentos" :key="erro_cancelamento.id_pedido">
                                <span>Id do pedido: {{ erro_cancelamento.id_pedido }} | Valor: {{
                                    moedaReal(erro_cancelamento.valor) }} | Forma: {{ erro_cancelamento.forma_pagamento
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <log-integracao-suporte-pos ref="logIntSuportePos" />
    </div>
</template>

<script>
import $ from "jquery";
import LogIntegracaoSuportePos from "../shared/audit/LogIntegracaoSuportePos.vue";

export default {
    data() {
        return {
            recepcoes_disponiveis: [],
            maquininha: null,
            pagamentos: [],
            itens_cancelamento: [],
            erros_cancelamentos: [],
            itens_pagamento_atendimento: [],
            id_item_pagamento_atendimento: null
        };
    },

    props: {
        id_pagamento_atendimento: {
            type: Number,
            required: true,
        },
        marcacao: {
            type: Object,
            required: false,
        },
        id_unidade_operacao: {
            type: Number,
            required: false,
        },
    },

    components: {
        LogIntegracaoSuportePos
    },

    methods: {

        abrirModalRecepcao() {
            $("#modalRecepcao").modal("show");
        },

        fecharModalRecepcao() {
            $("#modalRecepcao").modal("hide");
        },

        async abrirModalCancelamento() {
            await this.pegarFormasPagamento();
            $("#modalCancelamento").modal("show");
        },

        abrirModalErrosCancelamentos() {
            $("#modalErrosCancelamentos").modal("show");
        },

        fecharModalErrosCancelamentos() {
            $("#modalErrosCancelamentos").modal("hide");
        },

        fecharModalCancelamento() {
            $("#modalCancelamento").modal("hide");
        },

        abrirModalCartao() {
            $("#modalCartao").modal("show");
        },

        fecharModalCartao() {
            $("#modalCartao").modal("hide");
        },

        cancelarPagamento: function () {
            this.$util.atualizar(this, {
                service: "atendimentos",
                func: "suportpos_cancelar_pagamento",
                dados: {
                    id_pagamento_atendimento: this.id_pagamento_atendimento,
                    itens_cancelamento: this.itens_cancelamento
                },
                callback: (res) => {
                    this.fecharModalCancelamento()
                    this.itens_cancelamento = []
                    if (!res.ok) {
                        this.$toast.add({
                            severity: "error",
                            summary: "Aguarde",
                            detail: "Erro ao cancelar o(s) pagamento(s)",
                            life: 6000,
                        });
                        this.erros_cancelamentos = res.body
                        this.abrirModalErrosCancelamentos()
                    } else {
                        this.$toast.add({
                            severity: "success",
                            summary: "Aguarde",
                            detail: res.body,
                            life: 6000,
                        });
                    }
                },
            });
        },

        async pegarFormasPagamento() {
            await this.$util.atualizar(this, {
                service: "atendimentos",
                func: "suportpos_pegar_pagamento",
                dados: {
                    id_pagamento_atendimento: this.id_pagamento_atendimento
                },
                callback: (res) => {
                    this.pagamentos = res
                },
            });
        },

        pagar() {

            if (!this.maquininha) {
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Selecione uma maquininha",
                    life: 4000,
                });

                return;
            }

            this.$util.atualizar(this, {
                service: "atendimentos",
                func: "suportpos_pagar_pagamento",
                dados: {
                    id_pagamento_atendimento: this.id_pagamento_atendimento,
                    id_recepcao: this.maquininha.id_recepcao,
                    st_id_logico: this.maquininha.st_id_logico
                },

                callback: (res) => {
                    if (!res.ok) {

                        this.$toast.add({
                            severity: "error",
                            summary: "Erro",
                            detail: res.body,
                            life: 6000,
                        });

                    } else {

                        this.$toast.add({
                            severity: "success",
                            summary: "Sucesso",
                            detail: res.body,
                            life: 6000,
                        });

                    }

                    this.fecharModalRecepcao();
                },
            });
        },

        logComunicacao: function (id) {
            this.id_item_pagamento_atendimento = id;

            this.$refs.logIntSuportePos.abrir(
                "itemPagamentoAtendimento",
                id,
                true
            );
        },

        getRecepcoes() {
            this.$util.load(this, {
                service: "recepcoes_ecs",
                func: "listar_recepcoes_ecs",
                parms: {
                    id_recepcao: this.marcacao ? this.marcacao.id_recepcao : null,
                    id_unidade_operacao: this.id_unidade_operacao
                },
                loadTo: (res) => {
                    this.recepcoes_disponiveis = res;

                },
            });
        },

        getItensPagamentoAtendimento() {
            this.$util.atualizar(this, {
                service: "atendimentos",
                func: "suportpos_get_itens_pagamento_atendimento",
                dados: {
                    id_pagamento_atendimento: this.id_pagamento_atendimento
                },
                callback: (res) => {
                    this.itens_pagamento_atendimento = res
                },
            });
        },

        moedaReal(valor) {
            return valor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        },
    },


    mounted() {
        this.getRecepcoes();
        this.getItensPagamentoAtendimento();
    },
};
</script>
<style>
#cartaoModal {
    z-index: 99999;
}

.custom-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1040;
}
</style>
